import type { SelectOptionData } from './types.ts'

export const isItemVisible = <ValueType extends string>(
  { label }: SelectOptionData<ValueType>,
  search: string
) => {
  if (!search || search === '') {
    return true
  }

  return label.toLowerCase().includes(search.toLowerCase())
}

export const optionHeight = 45

export const getPlaceholderItem = (
  placeholder?: string
): SelectOptionData<string> => {
  const placeholderLabel = placeholder ?? 'Clear selection'

  return {
    label: placeholderLabel,
    value: placeholderLabel,
  }
}
